var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1881 23.8856C4.54905 24.6773 2.91675 25.7711 2.91675 26.9792C2.91675 29.3954 9.44593 31.3542 17.5001 31.3542C25.5542 31.3542 32.0834 29.3954 32.0834 26.9792C32.0834 25.7711 30.4511 24.6773 27.812 23.8856",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 25.5208C17.4999 25.5208 26.9791 19.3258 26.9791 12.1638C26.9791 7.05675 22.7351 2.91666 17.4999 2.91666C12.2647 2.91666 8.02075 7.05675 8.02075 12.1638C8.02075 19.3258 17.4999 25.5208 17.4999 25.5208Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 16.0417C19.5136 16.0417 21.1459 14.4094 21.1459 12.3958C21.1459 10.3823 19.5136 8.75 17.5001 8.75C15.4866 8.75 13.8542 10.3823 13.8542 12.3958C13.8542 14.4094 15.4866 16.0417 17.5001 16.0417Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocate);
export default __webpack_public_path__ + "static/media/icon-locate.041f8e8cc977ffc654f86a842652c332.svg";
export { ForwardRef as ReactComponent };